<template>
  <div class="add-products-modal-wrapper" v-if="$store.state.isAddModalOpen">
    <div class="add-products-modal-backdrop" @click="$store.commit('hideAddModal')"></div>
    <div class="add-products-modal-cards">
      <div class="add-products-modal-card selected-product-information">
        <div
          class="product-information-wrapper"
          v-if="$store.state.addItemModalData?.type && $store.state.addItemModalData?.product"
        >
          <img
            class="product-image"
            v-if="$store.state.addItemModalData.product?.icon"
            :src="$store.state.addItemModalData.product.icon"
            alt=""
          />
          <p
            class="product-category"
            v-if="$store.state.addItemModalData.type?.name && $store.state.addItemModalData.product?.name"
          >
            {{ $store.state.addItemModalData.type.name }}
          </p>
          <p class="product-title" v-if="$store.state.addItemModalData.product?.name">
            {{ $store.state.addItemModalData.product.name }}
          </p>
          <p class="product-color" v-if="$store.state.addItemModalData.variation?.name">
            <span class="label">{{ $store.state.addItemModalData.type.variation_label }}:&nbsp;</span
            >{{ $store.state.addItemModalData.variation.name }}
          </p>
          <p
            class="product-specifications"
            v-if="$store.state.addItemModalData?.product && $store.state.addItemModalData?.variation"
          >
            <span v-if="$store.state.addItemModalData.variation.dimensions">{{
              $store.state.addItemModalData.variation.dimensions
            }}</span>
            <span
              class="items"
              v-if="
                $store.state.addItemModalData.variation?.calculation_data?.items_per_palette &&
                $store.state.addItemModalData.type?.id !== 'sand' &&
                $store.state.addItemModalData.type?.id !== 'cement'
              "
              >{{ $store.state.addItemModalData.variation.calculation_data.items_per_palette }}/pack</span
            >
            <span
              class="coverage"
              v-if="$store.state.addItemModalData.variation?.calculation_data?.coverage_per_palette"
              >{{ $store.state.addItemModalData.variation.calculation_data.coverage_per_palette
              }}{{
                $store.state.addItemModalData.type?.id !== 'sand' && $store.state.addItemModalData.type?.id !== 'cement'
                  ? 'm²'
                  : 'm³'
              }}/pack</span
            >
          </p>
        </div>
        <div class="empty-message" v-else>No preview available</div>
      </div>
      <div class="add-products-modal-card form">
        <div class="form-title">
          Add Product to Quotation <span @click="$store.commit('hideAddModal')" class="close">x</span>
        </div>
        <div class="form-field full">
          <label for="product-type">Category</label>
          <v-select
            inputId="product-type"
            :options="$store.getters.getProductTypes"
            v-model="modalType"
            label="name"
          ></v-select>
        </div>
        <div class="form-field full">
          <label for="product-name">Product</label>
          <v-select
            inputId="product-name"
            :options="$store.getters.getProducts"
            label="name"
            v-model="modalProduct"
          ></v-select>
        </div>
        <div class="form-field full" v-if="$store.state.addItemModalData?.type">
          <label for="product-variation">{{ $store.state.addItemModalData.type.variation_label }}</label>
          <v-select
            inputId="product-variation"
            :options="$store.getters.getProductVariations"
            label="name"
            v-model="modalVariation"
          ></v-select>
        </div>
        <div class="form-field full dynamic-quantity">
          <label for="quantity">How many <i>{{ quantityLabelPart }}</i> do you require?</label>
          <div class="quantity-wrapper">
            <input
              type="number"
              name="quantity"
              id="quantity"
              class="white"
              v-model="modalQuantity"
              min="0"
              :step="modalQuantityType === 'single' ? 1 : 0.1"
            />
            <span class="radio-options dark">
              <span class="radio-button" v-if="$store.state.availableQuantities?.includes('sqm')">
                <input
                  type="radio"
                  name="quantity-type"
                  id="quantity-type"
                  value="sqm"
                  v-model="modalQuantityType"
                />
                <span class="radio-button-inner">m&sup2;</span>
              </span>
              <span class="radio-button" v-if="$store.state.availableQuantities?.includes('single')">
                <input
                  type="radio"
                  name="quantity-type"
                  id="quantity-type"
                  value="single"
                  v-model="modalQuantityType"
                />
                <span class="radio-button-inner">Singles</span>
              </span>
              <span class="radio-button" v-if="$store.state.availableQuantities?.includes('cubic')">
                <input
                  type="radio"
                  name="quantity-type"
                  id="quantity-type"
                  value="cubic"
                  v-model="modalQuantityType"
                />
                <span class="radio-button-inner">m&sup3;</span>
              </span>
            </span>
          </div>
        </div>
        <div class="form-field full buttons">
          <button type="button" class="btn secondary" @click.prevent="$store.commit('hideAddModal')">
            Cancel
          </button>
          <button type="button" class="btn primary" @click.prevent="updateCart">
            {{ $store.state.isEditing ? 'Update Product' : 'Add to Quotation' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	name: "add-product-modal",
	computed: {
		quantityLabelPart: function () {
			if (this.modalQuantityType === "single") {
				return "Single Item(s)";
			}
			if (this.modalQuantityType === "sqm") {
				return "Square Meters (m²)";
			}
			if (this.modalQuantityType === "cubic") {
				return "Cubic Meters (m³)";
			}
			return "N/A";
		},
		modalType: {
			get() {
				return this.$store.state.addItemModalData.type;
			},
			set(value) {
				this.$store.commit("updateAddModalData", {
					type: value,
				});
			},
		},
		modalProduct: {
			get() {
				return this.$store.state.addItemModalData.product;
			},
			set(value) {
				this.$store.commit("updateAddModalData", {
					product: value,
				});
			},
		},
		modalVariation: {
			get() {
				return this.$store.state.addItemModalData.variation;
			},
			set(value) {
				this.$store.commit("updateAddModalData", {
					variation: value,
				});
			},
		},
		modalQuantity: {
			get() {
				return this.$store.state.addItemModalData.quantity;
			},
			set(value) {
				this.$store.commit("updateAddModalData", {
					quantity: value,
				});
			},
		},
		modalQuantityType: {
			get() {
				return this.$store.state.addItemModalData.quantityType;
			},
			set(value) {
				this.$store.commit("updateAddModalData", {
					quantityType: value,
				});
			},
		},
	},
	methods: {
		updateCart() {
			this.$store.commit("updateCart");
		},
	},
};
</script>

<style lang="scss" scoped>
.add-products-modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 4995;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 768px) {
        flex-flow: row wrap;
        // height: auto;
        // min-height: 100%;
    }

    .empty-message {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.5;
    }

    .selected-product-information {
        .product-information-wrapper {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
        }

        .product-image {
            width: 150px;
        }

        .product-category,
        .product-title,
        .product-color {
            margin: 0;
            font-size: 16px;
        }

        .product-category {
            font-size: 14px;
            font-weight: 600;
            line-height: 14px;
            opacity: 0.5;
        }

        .product-title {
            font-size: 24px;
            font-weight: 600;
            line-height: 24px;
            margin-top: 4px;
            margin-bottom: 12px;
            text-align: center;
        }

        .product-color {
            position: relative;
            font-size: 16px;
            line-height: 16px;
            display: flex;
            align-items: center;
            // font-weight: 600;

            .color {
                width: 12px;
                height: 12px;
                background-color: #d2b48c;
                border-radius: 50%;
                display: inline-block;
                margin-left: 6px;
            }

            .label {
                font-weight: 600;
            }
        }

        .product-specifications {
            text-align: center;
            line-height: 1.6;
            span {
                display: block;
            }
        }
    }

    .add-products-modal-backdrop {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.25);
        backdrop-filter: blur(4px);
    }

    .add-products-modal-cards {
        display: flex;
        // align-items: center;
        // justify-content: center;
        position: relative;
        z-index: 100;
        flex-flow: row nowrap;
        // height: 100%;

        max-width: 720px;
        width: 100%;

        .add-products-modal-card {
            min-height: 20px;
            box-sizing: border-box;
            padding: 20px;
        }

        .add-products-modal-card.selected-product-information {
            background-color: #efefef;
            width: 35%;
            align-self: stretch;
        }

        .add-products-modal-card.form {
            background-color: white;
            width: 65%;

            .form-field:not(:last-child) {
                margin-bottom: 20px;
            }

            .form-title {
                font-weight: 600;
                font-size: 18px;
                margin-bottom: 20px;
                position: relative;
                padding-bottom: 6px;
                &::after {
                    content: '';
                    width: 60px;
                    height: 2px;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    background-color: $cl-primary;
                }

                .close {
                    position: absolute;
                    top: calc(50% - 6px);
                    right: 0;
                    transform: translateY(-50%);
                    opacity: 0.25;
                    user-select: none;
                    padding: 6px;
                    cursor: pointer;
                    &:hover {
                        opacity: 0.45;
                    }
                }
            }
            .buttons {
                display: flex;
                .primary {
                    flex-grow: 1;
                    margin-left: 8px;
                }
            }
        }

        .dynamic-quantity {
            .quantity-wrapper {
                display: flex;
                flex-flow: row nowrap;
                input {
                    margin-right: 10px;
                }
                .radio-options {
                    display: flex;
                    flex-flow: row nowrap;

                    .radio-button:not(:last-child) {
                        margin-right: 10px;
                    }
                }
            }
        }

        @media only screen and (max-width: 768px) {
            flex-flow: row wrap;
            max-height: 100vh;
            overflow-y: auto;
            padding: 20px;
            box-sizing: border-box;
            .add-products-modal-card {
                width: 100% !important;

                &.selected-product-information {
                    order: 2;
                    // display: none;
                    // min-height: 1280px;
                }
            }
        }
    }
}
</style>